const getStateFieldObject = (shippingStates) => {
  const stateProps = {
    isShippingField: true,
    name: 'shipping_state',
    label: 'State',
    required: true,
    validationMessage: 'Enter the shipping state',
  };

  if (shippingStates) {
    stateProps.type = 'choice';
    stateProps.choices = shippingStates;
  } else {
    stateProps.type = 'char';
  }

  return stateProps;
};

export const getShippingAddressFields = (shippingStates) => {
  return [{
    isShippingField: true,
    name: 'shipping_address',
    label: 'Shipping Address',
    type: 'text',
    required: true,
    placeholder: 'House number, bulding name, street name etc.',
    validationMessage: 'Enter the shipping address',
  }, {
    ...getStateFieldObject(shippingStates),
  }, {
    isShippingField: true,
    name: 'shipping_city',
    label: 'City',
    type: 'char',
    required: true,
    validationMessage: 'Enter the shipping city',
    grid: true,
  }, {
    isShippingField: true,
    name: 'shipping_zip',
    label: 'Postal Code',
    type: 'char',
    required: true,
    validationMessage: 'Enter the shipping postal code',
    hasCustomValidation: true,
    customValidation: (value) => /^[\d\s]{6,10}$/g.test(value) && value.replace(/\s/g, '').length >= 6,
    customValidationMessage: 'Enter a valid postal code',
    grid: true,
  }, {
    isShippingField: true,
    name: 'shipping_country',
    label: 'Country',
    type: 'choice',
    choices: [['India', 'India']],
    required: true,
  }];
};

export const customFieldsNormalizer = (fields = []) =>
  fields.reduce((normalizedFields, field) => {
    normalizedFields[field.name] = field;
    return normalizedFields;
  }, {});

export const customFormFields = ({ fields = [], prefilledCustomFields = {} }) =>
  fields.reduce((formFields, field) => {
    if (prefilledCustomFields[field.name]) {
      formFields[field.name] = prefilledCustomFields[field.name].value;
    } else if (field.name === 'shipping_country') {
      /*
       * Special case
       * ------------
       * default shipping_country to India
       */
      formFields[field.name] = 'India';
    } else {
      formFields[field.name] = '';
    }
    return formFields;
  }, {});



// WEBPACK FOOTER //
// ./src/payments/reducers/refine/customFields.js